//TO METERS: multiply unit by that factor
//FROM METERS: divide by that factor

const meterChart = {
  km:1e3,
  hm:1e2,
  dam:1e1,
  m:1e0,
  dm:1e-1,
  cm:1e-2,
  mm:1e-3,
  µm:1e-6,
  nm:1e-9,
  pm:1e-12,
  //inches
  
}

const imperialToMeters = {
  in:0.0254
}

const unitToMeterFactor = {
  ...meterChart,
  ...imperialToMeters
}

export const METRIC_UNITS = Object.keys(meterChart);
export const ALL_UNITS = Object.keys(unitToMeterFactor);

export function convertUnits({from,to,value}){


  let fromFactor = unitToMeterFactor[from] ;
  let toFactor =  unitToMeterFactor[to];



  let micro = "µm"


  if( !fromFactor ){
    debugger;
    throw Error(`'${from}' (from) not a registered unit.`);

  }else if( !toFactor ){
    debugger;
    throw Error(`'${to}' (to) not a registered unit.`);
  }
  let multiplyBy = fromFactor / toFactor;

  let result = value * multiplyBy;

  return result; 

}


